export const formatCurrency = (number: number) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(number);
export const displayNumber = (number?: number) =>
  typeof number === 'number' && !Number.isNaN(number) ? formatCurrency(number) : '-';
